<script>
import isEmpty from 'lodash.isempty'

export default {
    name: 'Favourite',
    props: {
        restaurant: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        disabled() {
            return isEmpty(this.restaurant)
        },
        isFavourite() {
            return this.disabled ? false : this.restaurant.is_favorite
        },
    },
    methods: {
        setFavourite() {
            if (!this.disabled) this.restaurant.favourite()
        },
    },
}
</script>

<template lang="pug">
button.btn.btn-icon.flex-shrink-0.btn-round(@click="setFavourite" :class="isFavourite ? 'btn-primary' : 'btn-secondary' " :disabled="disabled")
    icon(icon="fa-solid fa-heart")
</template>
